import React from 'react';
import { SimpleDialog } from 'src/components/SimpleDialog/SimpleDialog';
import {
  SignupErrorDialogVariant,
  SIGNUP_ERROR_DIALOG_COPY,
  SIGNUP_ERROR_DIALOG_BUTTON_TEXT,
} from 'src/components/selfService/features/Signup/components/SignupErrorDialog/signupErrorDialog.constants';

interface SignupErrorDialogProps {
  variant: SignupErrorDialogVariant;
  onDismiss: () => void;
}

export function SignupErrorDialog({
  variant,
  onDismiss,
}: SignupErrorDialogProps): JSX.Element {
  const { title, description } = SIGNUP_ERROR_DIALOG_COPY[variant];

  return (
    <SimpleDialog
      title={title}
      description={description}
      primaryActionText={SIGNUP_ERROR_DIALOG_BUTTON_TEXT}
      onPrimaryActionClick={onDismiss}
      buttonsDirection="column"
    />
  );
}
